"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { IconSize, Loop } from "../../icons";
import TruncatedText from "./TruncatedText";
export var TokenTheme = /* @__PURE__ */ ((TokenTheme2) => {
  TokenTheme2["Light"] = "light";
  TokenTheme2["Dark"] = "dark";
  return TokenTheme2;
})(TokenTheme || {});
let Token = class extends React.Component {
  constructor() {
    super(...arguments);
    this.dragLabelRef = createRef();
    this.onDragStart = (event) => {
      if (this.dragLabelRef.current) {
        const dragImageElement = this.dragLabelRef.current.cloneNode(true);
        document.body.appendChild(dragImageElement);
        dragImageElement.style.position = "absolute";
        dragImageElement.style.top = "-1000px";
        event.dataTransfer.setDragImage(dragImageElement, 15, 15);
        setTimeout(() => {
          document.body.removeChild(dragImageElement);
        });
      }
      if (this.props.onDragStart) {
        this.props.onDragStart(event);
      }
    };
  }
  render() {
    const { name, type, theme, isDraggable, onDragEnd } = this.props;
    const baseClass = `kl-token kl-token--${theme}`;
    const hasIcon = type === "list";
    const Icon = hasIcon && /* @__PURE__ */ React.createElement(Loop, { className: "kl-token__icon", size: IconSize.Small, "aria-label": "List" });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(baseClass, {
          "kl-token--draggable": isDraggable,
          "kl-token--has-icon": hasIcon
        }),
        title: name,
        draggable: isDraggable,
        onDragStart: this.onDragStart,
        onDragEnd
      },
      Icon,
      /* @__PURE__ */ React.createElement(TruncatedText, { className: "kl-token__name" }, name),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(baseClass, "kl-token--dragging kl-token__hidden-drag-label", {
            "kl-token--has-icon": hasIcon
          }),
          ref: this.dragLabelRef,
          "aria-hidden": true
        },
        Icon,
        /* @__PURE__ */ React.createElement("div", { className: "kl-token__name" }, name)
      )
    );
  }
};
Token.defaultProps = {
  theme: "light" /* Light */
};
Token = __decorateClass([
  observer
], Token);
export default Token;
